import React from 'react'
import { FaBookOpen } from "react-icons/fa";

const tuitionData = [
  { grade: "9th", description: "Stateboard tuition for 9th standard Mathematics, Science, Social Science, English,Tamil,etc" },
  { grade: "10th", description: "Stateboard tuition for 10th standard Mathematics, Science, Social Science, English,Tamil,etc" },
  { grade: "11th", description: "Stateboard tuition for 11th standard Mathematics, Science, Social Science, English,Tamil,etc" },
  { grade: "12th", description: "Stateboard tuition for 12th standard Mathematics, Science, Social Science, English,Tamil,etc" },
 
];
const Stateboard = () => {
  return (
    <div className="min-h-screen  p-6">
        <div className="w-full max-w-screen-xl mx-auto">
          {/* Page Header */}
          <h1 className="text-4xl font-bold text-[#1ba6db] mb-6 text-center">
          State Board courses
          </h1>
          <p className="text-lg text-gray-700 max-w-screen-lg mx-auto text-center mb-6">
          The Tamil Nadu State Board of School Examination evaluates students' progress by conducting two board examinations - one at the end of class 10 and the other at the end of class 12.
          </p>
          {/* Courses Information */}
         {/* Tuition Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {tuitionData.map((tuition, index) => (
              <div key={index} className="max-w-sm bg-white shadow-[0px_0px_15px_rgba(0,0,0,0.09)] p-9 space-y-3 relative overflow-hidden">
                {/* Circle Badge */}
                <div className="w-24 h-24 bg-[#1ba6db] rounded-full absolute -right-5 -top-7 flex items-center justify-center">
                  <p className="text-white text-2xl font-semibold">{tuition.grade}</p>
                </div>
                {/* React Icon */}
                <div className="text-[#1ba6db] text-4xl">
                  <FaBookOpen /> 
                </div> 
                 
                {/* Heading */} 
                <h1 className="font-bold text-xl">{tuition.grade} Tuition</h1>
                {/* Description */}
                <p className="text-sm text-zinc-500 leading-6">{tuition.description}</p>

              </div>
            ))}
          </div>
          <div className="mt-8">
            <h2 className="text-3xl font-semibold text-[#1ba6db] mb-4">Courses Info</h2>
            <p className="text-gray-800 text-lg leading-relaxed mb-4">
            Tuitions in Vellore for ICSE is provided by Kalamji Academy, we train students for their board exams with our special strategy and techniques, Kalamji Academy have a lot of expert professional tutors who provide question paper patterns and important topics and questions to the students. We train students in such way that makes them easier to learn and understand things better.
            </p>
            <p className="text-gray-800 text-lg leading-relaxed mb-4">
            Kalamji Academy is also very famous for the mathematics tuition; We make students understand each problem in a unique and easy way, We also help students solve each type of problem until they succeed and understand thoroughly, We are one of the best maths tuition Centre in Vellore.
            </p>
            <p className="text-gray-800 text-lg leading-relaxed">
            We also provide special sheets of important questions to the students which will be ultimate help for the board exams; We don’t burden students but make everything so enthusiastic which makes students grasp everything and they gain ultimate knowledge and trained mind that makes success chase them. These features are provided only by Kalamji Academy which is one of the best 10th and 12th standard tuition centres in Vellore.
            </p>
          </div>
        </div>
      </div>
  )
}

export default Stateboard